// extracted by mini-css-extract-plugin
export default {"top-shadow":"HeadBand_top-shadow__g4woB","bottom-shadow":"HeadBand_bottom-shadow__ZPtp9","container":"HeadBand_container__Exy9P"};